module.exports = __webpack_public_path__ + "img/nabl_gallery10.0407401d.jpg";